import { Injectable, effect, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AuthStore } from '@features/shared/auth/presentation/store/auth.store';
import { LANGUAGE_STORAGE_KEY } from '@shared/constants/storage-keys.const';
import { isAppLanguageCode } from '@shared/constants/app-languages.const';
import { WebStorageService } from '@shared/storage/web-storage.service';

@Injectable({ providedIn: 'root' })
export class WebLanguagePreferenceService {
  private readonly authStore = inject(AuthStore);
  private readonly transloco = inject(TranslocoService);
  private readonly storage = inject(WebStorageService);

  constructor() {
    effect(() => {
      if (isAppLanguageCode(this.storage.getItem(LANGUAGE_STORAGE_KEY))) return;
      this.transloco.setActiveLang(this.authStore.user()?.organizationDefaultLanguage ?? 'es');
    });
  }
}
